import { render, staticRenderFns } from "./BoxPerformanceComparisonLineDistrict.vue?vue&type=template&id=19047d0c&scoped=true&"
import script from "./BoxPerformanceComparisonLineDistrict.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonLineDistrict.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonLineDistrict.vue?vue&type=style&index=0&id=19047d0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19047d0c",
  null
  
)

export default component.exports
import {QCard,QBtnToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle})
